<template>
  <i-select :value="current_contact" :clearable="true" @input="input">
    <i-option
      v-for="(item, key) in contacts"
      :key="key"
      :value="item.id"
      :label="`${item.last_name} ${item.first_name}`"
    />
  </i-select>
</template>

<script>
  import { ContactService } from '@pbx/services/ContactService';

  export default {
    data: () => ({
      contacts: [],
      current_contact: null
    }),
    async mounted() {
      this.contacts = await ContactService.getSelect();
    },
    methods: {
      input(id) {
        this.current_contact = id;
        this.$emit('input', id);
      }
    }
  };
</script>
